// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactList_wrapper__XG0a2","leftWrapper":"ContactList_leftWrapper__4DyYN","divider":"ContactList_divider__c7q2a","lockIcon":"ContactList_lockIcon__O9IG5"};